export const LOAN_AMOUNT_MIN = 10000;
export const LOAN_AMOUNT_MAX = 300000;
